export default __webpack_public_path__ + "static/media/profile.c8d53840.jpg";